<template>
  <div :class="['flash-message', `--is-${type}`]">
    <i v-if="type === 'warning'" class="icon icon-exclamation-circle"></i>
    <i v-else-if="type === 'error'" class="icon icon-times"></i>
    <i v-else class="icon icon-info-circle"></i>

    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FlashMessage',
  props: {
    type: {
      type: String,
      default: 'info'
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * FlashMessage
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Flash Message to use within and solely in Composer, not any other module
 * @since 2021-09-24
**/

$component: 'flash-message';

.#{$component} {
  display: flex;
  align-items: flex-start;
  @include margin-bottom(map-get($spacers, 3));
  @include padding(map-get($spacers, 2) map-get($spacers, 2));
  border-top: 2px solid $gray-ghost;
  border-radius: $border-radius-lg;
  background-color: lighten($aqua, 10%);
  color: $ink-lighter;
  @include font-size($font-size-base);

  .icon {
    @include margin-right(map-get($spacers, 2));
    color: darken($aqua, 40%);
    @include font-size($font-size-lg * 1.4);
  }

  p {
    margin: 0;
  }

  &.--is-warning {
    border-top-color: $yellow;
    background-color: lighten($yellow, 16%);

    .icon {
      color: darken($yellow, 32%);
    }
  }

  &.--is-error {
    border-top-color: $red;
    background-color: lighten($red, 30%);

    .icon {
      color: darken($red, 20%);
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
